import { Role } from './role.enum';

export const Roles = {
  ...Role,
};

export type Roles = Role;